import CommentPresenter from '../../helpers/CommentPresenter'
import MentionRender from '../../helpers/MentionRender'
import StringVueCompiler from '../../helpers/StringVueCompiler'
import { Emoji } from 'emoji-mart-vue'

export default {
    assets (state) {
        return state.assets.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
    },

    commentsWithAttachments (state) {
        return state.comments.items.filter(comment => comment.attachment !== null)
    },

    imageCount (state, getters) {
        return getters.commentsWithAttachments.filter(comment => comment.attachment.is_image).length
    },

    presentedComments (state, getters, rootState) {
        let presenter = new CommentPresenter(new MentionRender(rootState.tenant.users))

        presenter.setEmojiResolver((emojiCode) => {
            if (emojiCode === ':undefined:') {
                return ''
            }

            return StringVueCompiler.compile(`<emoji :size="16" emoji="${emojiCode}"></emoji>`, { Emoji })
        })

        return presenter.present(state.comments.items)
    }
}
